module.exports = __webpack_public_path__ + "static/media/pana.f6080bd2.svg";